import React from 'react';
import classNames from 'classnames';
import CardInfo from './cardInfo';
import CardStatus from './cardStatus';
import {timeFromCreated} from 'utilities/helper/timeFromCreated';
interface CardAdProps {
  wrapperClassName?: string;
  type: 'wanted-post';
  status: 'published' | 'rejected' | 'pending';
  app: 'farm' | 'wholesaler';
  item: IGetMyWantedsResults;
  refetch: () => void;
}
const CardAd = ({
  status,
  app,
  type,
  item,
  wrapperClassName,
  refetch,
}: CardAdProps) => {
  return (
    <div
      className={classNames(
        'flex bg-white justify-between rounded-lg h-36 mx-2 px-2 py-4  shadow-md w-72 mb-3',
        wrapperClassName,
      )}
    >
      <div className="flex flex-col w-full justify-around">
        <CardInfo
          grade={item.quality}
          title={item.title}
          icon={item.product_category.icon}
        />
        <div className="flex w-full items-center gap-2">
          <span className="icon-location text-primary text-xs " />
          <p className="flex gap-1  font-normal text-xs text-gray-6">
            <span>{item.state}</span> , <span>{item.city}</span>
          </p>
        </div>
        <CardStatus
          type={type}
          refetch={refetch}
          app={app}
          guid={item.guid}
          createdDate={timeFromCreated(item.created_at)}
          status={status}
        />
      </div>
    </div>
  );
};

export default CardAd;
